import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Connections = lazy(() => import("@/pages/Connections"));
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
export const Route = createFileRoute("/connections")({
  component: () => (
    <ProtectedRoute>
      <Connections />
    </ProtectedRoute>
  ),
});
